<template>
  <tux-cvc-verification
    secondary-cta="cvc.secondaryCTA"
    :manual-error-token.sync="cvcErrorToken"
    :is-successful="isSuccessful"
    :pan-last-four="panLastFour"
    @submit="submit"
    @cancel="cancel" />
</template>

<script>
import nudetect from '@mc-alberta/nudetect'
import { CustomLogger } from '@mc-alberta/supernova-scripts'
import { TuxCvcVerification } from '@mc-alberta/tuxedo'
import { mapActions, mapGetters, mapState } from 'vuex'
import { LOADERS, ROUTES } from '@/constants'

export default {
  name: ROUTES.CVC,
  components: {
    TuxCvcVerification
  },
  data() {
    return {
      panLastFour: '',
      cvcErrorToken: '',
      isSuccessful: false,
      oldestCard: this.$route.params.oldestCard,
      mobileNumber: this.$route.params.mobileNumber
    }
  },
  computed: {
    ...mapState({
      cardAuthToken: (state) => state.cards.cardAuthToken,
      serviceLayerError: (state) => state.serviceLayerError
    }),
    ...mapGetters(['isLoading', 'oldestActiveCard', 'serviceErrorResponse'])
  },
  created() {
    this.panLastFour = this.oldestCard?.primaryAccountNumberSuffix.toString()

    if (!this.panLastFour) {
      this.cancel()
    }
  },
  mounted() {
    this.$nextTick(() => nudetect.beginBehaviouralMonitoring())
  },
  beforeDestroy() {
    this.clearServiceLayerError()
  },
  methods: {
    ...mapActions([
      'clearServiceLayerError',
      'setMessagePageContent',
      'startLoader',
      'stopLoader',
      'validateCvc',
      'verifyChannel'
    ]),
    async submit(cvcCode) {
      if (this.isLoading) {
        // submit already inflight, log a 2nd attempt
        CustomLogger.error({
          event: 'MULTI_OTP_SUBMIT_ATTEMPT',
          error: new Error('Attempting to submit OTP multiple times.'),
          details: {
            routeName: this.$route.name,
            routePath: this.$route.path
          }
        })
        return
      }

      this.startLoader(LOADERS.VERIFY_DETAILS)

      this.clearServiceLayerError()

      const cardId = this.oldestCard.id
      await this.validateCvc({ cvcCode, cardId })

      nudetect.clearBehaviouralData()

      if (this.serviceLayerError) {
        this.handleError()
        return
      }

      this.isSuccessful = true

      await this.verifyChannel({ phone: this.mobileNumber, cardAuthToken: this.cardAuthToken })

      if (!this.serviceLayerError) {
        this.$router.push({
          name: ROUTES.VERIFY_MOBILE,
          params: { skipConfirmation: true, showStepTracker: true, totalStep: 2 }
        })
        this.stopLoader(LOADERS.VERIFY_DETAILS)
      } else {
        this.handleError()
      }
    },
    cancel() {
      this.$router.replace({ name: ROUTES.CONTACT_INFORMATION_SETTINGS })
    },

    handleError() {
      const { status, data } = this.serviceErrorResponse() || {}

      if (status === 400 && data.status === 'INVALID_STATE') {
        nudetect.beginBehaviouralMonitoring()
        this.cvcErrorToken = 'cvc.error'
      } else {
        this.$router.replace({
          name: ROUTES.CONTACT_INFORMATION_SETTINGS,
          params: { errorToken: 'error.default' }
        })
      }

      this.stopLoader(LOADERS.VERIFY_DETAILS)
    }
  }
}
</script>
